import React from 'react'
import { Grid, SelectChangeEvent } from '@mui/material'

import { ButtonResetTableFilters, DateRange, DebouncedTextField, Select } from '@/components'
import { useAppDispatch, useAppSelector } from '@/stores/hooks.ts'
import {
  acquiringPaymentsActions,
  acquiringPaymentSelectors,
  AcquiringTableState,
} from '@/stores/slices/acquiring-payments-slice.ts'
import { AcqStatus } from '@/types.ts'

const STATE_ITEMS: Array<{ value: AcqStatus | 'ALL'; label: string }> = [
  { value: 'ALL', label: 'Все' },
  { value: 'ACCEPTED', label: 'Проведён' },
  { value: 'REGISTERED', label: 'Зарегистрирован' },
  { value: 'NOT_PAID', label: 'Не оплачен' },
  { value: 'PAID', label: 'Оплачен' },
  { value: 'REVERSED', label: 'Возвращён' },
  { value: 'PARTIAL_REVERSED', label: 'Частично возвращён' },
  { value: 'CANCELED', label: 'Отменён' },
  { value: 'HOLD', label: 'Зарезервирован' },
]

const resettableKeyFilters: (keyof AcquiringTableState)[] = ['dateTo', 'dateFrom', 'clientFio', 'state']

export const AcquiringPaymentsFilters = (): React.ReactElement => {
  const state = useAppSelector((state) => state.acquiringPayments.state)
  const clientFio = useAppSelector((state) => state.acquiringPayments.clientFio)
  const dateRange = useAppSelector((state) => [state.acquiringPayments.dateFrom, state.acquiringPayments.dateTo])
  const resettableStateFilters = useAppSelector((state) =>
    acquiringPaymentSelectors.resettableStateFilters(state, resettableKeyFilters)
  )
  const dispatch = useAppDispatch()

  const handleStateChange = (event: SelectChangeEvent) => {
    dispatch(acquiringPaymentsActions.setFilter({ filterKey: 'state', filterValue: event.target.value }))
  }
  const handleClientFioChange = (value: string) =>
    dispatch(acquiringPaymentsActions.setFilter({ filterKey: 'clientFio', filterValue: value }))

  const handleDateChange = (value: [string?, string?]) => {
    dispatch(acquiringPaymentsActions.setFilter({ filterKey: 'dateFrom', filterValue: value[0] }))
    dispatch(acquiringPaymentsActions.setFilter({ filterKey: 'dateTo', filterValue: value[1] }))
  }

  const resetFilters = () => dispatch(acquiringPaymentsActions.resetFilters(resettableKeyFilters))

  return (
    <>
      <Grid container spacing={2} flexDirection="row">
        <Grid item xs={12} md={4} lg={2}>
          <Select items={STATE_ITEMS} label="Статус" labelId="acq-select" onChange={handleStateChange} value={state} />
        </Grid>
        <Grid item xs={12} md={8} lg={5}>
          <DateRange initialRange={dateRange} onChange={handleDateChange} />
        </Grid>
        <Grid item xs={12} md={6} lg={2}>
          <DebouncedTextField
            initValue={clientFio}
            label="ФИО клиента"
            onChange={handleClientFioChange}
            doReset={clientFio === undefined}
          />
        </Grid>
        <Grid item xs={12} md={6} lg={3}>
          <ButtonResetTableFilters stateFilters={resettableStateFilters} onResetFilters={resetFilters} />
        </Grid>
      </Grid>
    </>
  )
}
